export default "__VITE_ASSET__DdoZ6CFC__"